import { apiService } from '@clarix/api-client';
import { pmsBase } from '../lib/base';
import { PMS_ENDPOINTS } from '../endpoints';
import type {
  CompetencyCategory,
  CreateCategoryPayload,
  UpdateCategoryPayload,
} from '../types';

export const categoriesApi = {
  list: () =>
    apiService.get<CompetencyCategory[]>(`${pmsBase()}${PMS_ENDPOINTS.CATEGORIES}`),

  create: (data: CreateCategoryPayload) =>
    apiService.post<CompetencyCategory>(`${pmsBase()}${PMS_ENDPOINTS.CATEGORIES}`, data),

  update: (categoryId: string, data: UpdateCategoryPayload) =>
    apiService.put<CompetencyCategory>(
      `${pmsBase()}${PMS_ENDPOINTS.CATEGORIES}/${categoryId}`,
      data,
    ),

  delete: (categoryId: string) =>
    apiService.delete<void>(`${pmsBase()}${PMS_ENDPOINTS.CATEGORIES}/${categoryId}`),
};
